/*** IMPORTS FROM imports-loader ***/
(function() {

define([
  'jquery',
  'pip-model',
  'cookie-utils',
  'pip-domain',
  'window',
  'breakpoints'
],
  function (
    $,
    pip,
    cookieUtils,
    pipDomain,
    window,
    breakpoints
  ) {
    var MESSAGING_STATES = {
      SUCCESS: {
        STYLE: 'alert-inline--success',
        BUTTON: {
          DISABLED: false
        }
      },
      ERROR: {
        STYLE: 'alert-inline--danger',
        BUTTON: {
          DISABLED: true
        }
      },
      WARNING: {
        STYLE: 'alert-inline--warning',
        BUTTON: {
          DISABLED: false
        }
      }
    };

    function buildURLWithParams(baseURL, params) {
      //TODO: potentially add location.protocol here, but what about relative paths?
      if (baseURL.substr(-1) === '?') return baseURL + $.param(params);
      return baseURL + "?" + $.param(params);
    }

    function makeDeliveryCapacityCall(itemId, zipCode, quantity) {
      return $.ajax({
        type: "GET",
        timeout: 6000,
        url: '/p/svcs/getBodfsInventoryCapacity?itemId=' + itemId + '&bodfsZipCode=' + zipCode + '&quantity=' + quantity,
        cache: false,
        dataType: "json"
      });
    }

    function getBodfsDetails(itemId, zipCode, quantity) {
      return $.ajax({
        type: "GET",
        timeout: 6000,
        url: '/p/svcs/bodfs/inventory-capacity?itemId=' + itemId + '&bodfsZipCode=' + zipCode + '&quantity=' + quantity,
        cache: false,
        dataType: "json"
      });
    }

    // Returns nested property value in object or null if it's not found.
    function getNestedProp(propPathArray, objectToQuery) {
      if (propPathArray && propPathArray instanceof Array && objectToQuery) {
        return propPathArray.reduce(function (accumulator, currentValue) {
          return accumulator && typeof accumulator[currentValue] !== 'undefined'
            ? accumulator[currentValue]
            : null;
        }, objectToQuery);
      }
      return null;
    }

    //Sets cookie in .environment(Example - .homedepot.com) domain
    function setCookieWithDomain(name, value, days) {
      window.document.cookie = getCookieWithDomain(name, value, days)
    }

    function getCookieWithDomain(name, value, days) {
      /* eslint-enable*/
      var expires;
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toGMTString();
      } else {
        expires = '';
      }
      var cookieWithDomain = name + '=' + value + expires + '; path=/; domain=' + pipDomain.getCookieDomain();
      return cookieWithDomain;
    }

    function deepGet(object, key) {
      return key.split('.').reduce(function (innerObject, innerKey) {
        return (innerObject === undefined || innerObject === null) ? innerObject : innerObject[innerKey];
      }, object);
    }

    function getAttributeValueByGroupAndGuid(pip, attributeGroupType, attributeGuid) {
      var attributeGroups = deepGet(pip, 'products.primary.data.attributeGroups');
      if (!attributeGroups) {
        return null;
      }
      var matchingGroups = attributeGroups.filter(function (attributeGroup) {
        return ((attributeGroup.groupType === attributeGroupType) && attributeGroup.entries && attributeGroup.entries.length);
      })
      if (!matchingGroups.length) {
        return null
      }
      var attributeEntry = matchingGroups[0].entries.filter(function (entry) {
        return entry.guid === attributeGuid;
      });
      return attributeEntry && attributeEntry[0] && attributeEntry[0].value;
    }

    function getTooltipSize() {
      if (!breakpoints) {
        return 'medium';
      }

      if (!(pip.features.pipUtilGetBreakpointEnabled)) {
        return breakpoints.isActiveBreakpointEqualToOrSmallerThan('Small') ? 'medium' : 'large';
      }

      var currentBreakPoint = breakpoints.getCurrentBreakpoint();

      switch (currentBreakPoint) {
        case 'ExtraSmall':
          return 'small';

        case 'Small':
        case 'Medium':
          return 'medium'

        case 'Large':
        case 'ExtraLarge':
          return 'large';

        default:
          return 'medium';
      }
    }

    function isAfterBopisCutoff() {
      var bopisCutoffHour = 14;
      return new Date().getHours() >= bopisCutoffHour;
    }

    var pricing = {
      formatPrice: function formatPrice(rawPrice) {
        var parsedPrice = parseFloat(rawPrice).toFixed(2).toString().split('.');
        var formattedPrice = '';
        var dollars = parsedPrice[0];
        var cents = parsedPrice[1];
        var lessThanDollar = false;

        if (dollars < 1) {
          lessThanDollar = true;
          formattedPrice = cents + '¢';
        } else {
          formattedPrice = '$' + pricing.addCommas(rawPrice);
        }

        return {
          formatted: formattedPrice,
          dollars: dollars,
          cents: cents,
          lessThanDollar: lessThanDollar
        }
      },
      addCommas: function addCommas(price) {
        return parseFloat(price).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    };

    return {
      MESSAGING_STATES: MESSAGING_STATES,
      makeDeliveryCapacityCall: makeDeliveryCapacityCall,
      buildURLWithParams: buildURLWithParams,
      trimInlineTitle: function trimInlineTitle(wrapper, charCount) {
        var getTitleStr = $(wrapper).text();
        if (getTitleStr != undefined && getTitleStr.length > charCount) {
          var trimInlineTitle = getTitleStr.substring(0, charCount - 3);
          var str = trimInlineTitle.substring(0, Math.min(trimInlineTitle.length, trimInlineTitle.lastIndexOf(" ")));
          $(wrapper).text(str + "...");
        }
      },
      updateHeaderATCcounter: function updateHeaderATCcounter() {
        cookieUtils.cookieManager.initializeMasterCookie();
        $(document).trigger({
          type: "cartUpdated"
        });
      },
      getNestedProp: getNestedProp,
      getBodfsDetails: getBodfsDetails,
      deepGet: deepGet,
      getAttributeValueByGroupAndGuid: getAttributeValueByGroupAndGuid,
      isAfterBopisCutoff: isAfterBopisCutoff,
      setCookieWithDomain: setCookieWithDomain,
      getCookieWithDomain: getCookieWithDomain,
      getTooltipSize: getTooltipSize,
      pricing: pricing
    }
  });

}.call(window));